'use strict';
angular.module('cvsApp').factory('symptomTrackerEligibilityModal', ['commonModel', function (CM) {

	var symptomTrackerEligibilityModal = function () {

        var self = this;
        var apiResponse = {};

		this.setResponse = function(data){
			CM.setAGPResponse(data,'findSymptomTrackerEligibilityResponse');
		 }

		 this.getResponse = function(){
            apiResponse = CM.getResponse();
            return self;
		}
		
		this.getError = function(){
            if(apiResponse.showError){
                return apiResponse.showError;
            }
            return '';
		}

		this.eligibilityResponseDetails = function(){
            return apiResponse
        }

	};

	return new symptomTrackerEligibilityModal();
}]);